import { Injectable } from '@angular/core';
import { DetalheAtributoModel } from '@app/data';
import { ApiService } from '@app/gateway';
import type { DashPeriodQueryPayload } from '@app/pages/dashboard/shared';

export type CmvDetalheDimension = 'grupo' | 'subgrupo' | 'secao' | 'marca' | 'fabricante' | 'vendedor';

@Injectable({ providedIn: 'root' })
export class CmvService {
  constructor(protected readonly apiService: ApiService) {}

  public async detalheCmv(dimension: CmvDetalheDimension, data: DashPeriodQueryPayload): Promise<DetalheAtributoModel[]> {
    try {
      const path: string = `cmv/detalheCmv`;
      const result: DetalheAtributoModel[] = await this.apiService.post({ path, data: { ...data, dimension } });
      return result;
    } catch (e: unknown) {
      const message: string = e instanceof Error ? e.message : 'Failed to load CMV detail.';
      throw new Error(message, { cause: e });
    }
  }
}
